/** Annex C — FIFA World Cup 2026 third-place combinations (495 rows). */
export const ANNEX_C_WINNERS = ["A","B","D","E","G","I","K","L"] as const;

export const ANNEX_C_ROWS: readonly string[] = [
    'EJIFHGLK',
  'HGIDJFLK',
  'EJIDHGLK',
  'EJIDHFLK',
  'EGIDJFLK',
  'EGJDHFLK',
  'EGIDHFLK',
  'EGJDHFLI',
  'EGJDHFIK',
  'HGICJFLK',
  'EJICHGLK',
  'EJICHFLK',
  'EGICJFLK',
  'EGJCHFLK',
  'EGICHFLK',
  'EGJCHFLI',
  'EGJCHFIK',
  'HGICJDLK',
  'CJIDHFLK',
  'CGIDJFLK',
  'CGJDHFLK',
  'CGIDHFLK',
  'CGJDHFLI',
  'CGJDHFIK',
  'EJICHDLK',
  'EGICJDLK',
  'EGJCHDLK',
  'EGICHDLK',
  'EGJCHDLI',
  'EGJCHDIK',
  'CJEDIFLK',
  'CJEDHFLK',
  'CEIDHFLK',
  'CJEDHFLI',
  'CJEDHFIK',
  'CGEDJFLK',
  'CGEDIFLK',
  'CGEDJFLI',
  'CGEDJFIK',
  'CGEDHFLK',
  'CGJDHFLE',
  'CGJDHFEK',
  'CGEDHFLI',
  'CGEDHFIK',
  'CGJDHFEI',
  'HJBFIGLK',
  'EJIBHGLK',
  'EJBFIHLK',
  'EJBFIGLK',
  'EJBFHGLK',
  'EGBFIHLK',
  'EJBFHGLI',
  'EJBFHGIK',
  'HJBDIGLK',
  'HJBDIFLK',
  'IGBDJFLK',
  'HGBDJFLK',
  'HGBDIFLK',
  'HGBDJFLI',
  'HGBDJFIK',
  'EJBDIHLK',
  'EJBDIGLK',
  'EJBDHGLK',
  'EGBDIHLK',
  'EJBDHGLI',
  'EJBDHGIK',
  'EJBDIFLK',
  'EJBDHFLK',
  'EIBDHFLK',
  'EJBDHFLI',
  'EJBDHFIK',
  'EGBDJFLK',
  'EGBDIFLK',
  'EGBDJFLI',
  'EGBDJFIK',
  'EGBDHFLK',
  'HGBDJFLE',
  'HGBDJFEK',
  'EGBDHFLI',
  'EGBDHFIK',
  'HGBDJFEI',
  'HJBCIGLK',
  'HJBCIFLK',
  'IGBCJFLK',
  'HGBCJFLK',
  'HGBCIFLK',
  'HGBCJFLI',
  'HGBCJFIK',
  'EJBCIHLK',
  'EJBCIGLK',
  'EJBCHGLK',
  'EGBCIHLK',
  'EJBCHGLI',
  'EJBCHGIK',
  'EJBCIFLK',
  'EJBCHFLK',
  'EIBCHFLK',
  'EJBCHFLI',
  'EJBCHFIK',
  'EGBCJFLK',
  'EGBCIFLK',
  'EGBCJFLI',
  'EGBCJFIK',
  'EGBCHFLK',
  'HGBCJFLE',
  'HGBCJFEK',
  'EGBCHFLI',
  'EGBCHFIK',
  'HGBCJFEI',
  'HJBCIDLK',
  'IGBCJDLK',
  'HGBCJDLK',
  'HGBCIDLK',
  'HGBCJDLI',
  'HGBCJDIK',
  'CJBDIFLK',
  'CJBDHFLK',
  'CIBDHFLK',
  'CJBDHFLI',
  'CJBDHFIK',
  'CGBDJFLK',
  'CGBDIFLK',
  'CGBDJFLI',
  'CGBDJFIK',
  'CGBDHFLK',
  'CGBDHFLJ',
  'HGBCJFDK',
  'CGBDHFLI',
  'CGBDHFIK',
  'HGBCJFDI',
  'EJBCIDLK',
  'EJBCHDLK',
  'EIBCHDLK',
  'EJBCHDLI',
  'EJBCHDIK',
  'EGBCJDLK',
  'EGBCIDLK',
  'EGBCJDLI',
  'EGBCJDIK',
  'EGBCHDLK',
  'HGBCJDLE',
  'HGBCJDEK',
  'EGBCHDLI',
  'EGBCHDIK',
  'HGBCJDEI',
  'CJBDEFLK',
  'CEBDIFLK',
  'CJBDEFLI',
  'CJBDEFIK',
  'CEBDHFLK',
  'CJBDHFLE',
  'CJBDHFEK',
  'CEBDHFLI',
  'CEBDHFIK',
  'CJBDHFEI',
  'CGBDEFLK',
  'CGBDJFLE',
  'CGBDJFEK',
  'CGBDEFLI',
  'CGBDEFIK',
  'CGBDJFEI',
  'CGBDHFLE',
  'CGBDHFEK',
  'HGBCJFDE',
  'CGBDHFEI',
  'HJIFAGLK',
  'EJIAHGLK',
  'EJIFAHLK',
  'EJIFAGLK',
  'EGJFAHLK',
  'EGIFAHLK',
  'EGJFAHLI',
  'EGJFAHIK',
  'HJIDAGLK',
  'HJIDAFLK',
  'IGJDAFLK',
  'HGJDAFLK',
  'HGIDAFLK',
  'HGJDAFLI',
  'HGJDAFIK',
  'EJIDAHLK',
  'EJIDAGLK',
  'EGJDAHLK',
  'EGIDAHLK',
  'EGJDAHLI',
  'EGJDAHIK',
  'EJIDAFLK',
  'HJEDAFLK',
  'HEIDAFLK',
  'HJEDAFLI',
  'HJEDAFIK',
  'EGJDAFLK',
  'EGIDAFLK',
  'EGJDAFLI',
  'EGJDAFIK',
  'HGEDAFLK',
  'HGJDAFLE',
  'HGJDAFEK',
  'HGEDAFLI',
  'HGEDAFIK',
  'HGJDAFEI',
  'HJICAGLK',
  'HJICAFLK',
  'IGJCAFLK',
  'HGJCAFLK',
  'HGICAFLK',
  'HGJCAFLI',
  'HGJCAFIK',
  'EJICAHLK',
  'EJICAGLK',
  'EGJCAHLK',
  'EGICAHLK',
  'EGJCAHLI',
  'EGJCAHIK',
  'EJICAFLK',
  'HJECAFLK',
  'HEICAFLK',
  'HJECAFLI',
  'HJECAFIK',
  'EGJCAFLK',
  'EGICAFLK',
  'EGJCAFLI',
  'EGJCAFIK',
  'HGECAFLK',
  'HGJCAFLE',
  'HGJCAFEK',
  'HGECAFLI',
  'HGECAFIK',
  'HGJCAFEI',
  'HJICADLK',
  'IGJCADLK',
  'HGJCADLK',
  'HGICADLK',
  'HGJCADLI',
  'HGJCADIK',
  'CJIDAFLK',
  'HJFCADLK',
  'HFICADLK',
  'HJFCADLI',
  'HJFCADIK',
  'CGJDAFLK',
  'CGIDAFLK',
  'CGJDAFLI',
  'CGJDAFIK',
  'HGFCADLK',
  'CGJDAFLH',
  'HGJCAFDK',
  'HGFCADLI',
  'HGFCADIK',
  'HGJCAFDI',
  'EJICADLK',
  'HJECADLK',
  'HEICADLK',
  'HJECADLI',
  'HJECADIK',
  'EGJCADLK',
  'EGICADLK',
  'EGJCADLI',
  'EGJCADIK',
  'HGECADLK',
  'HGJCADLE',
  'HGJCADEK',
  'HGECADLI',
  'HGECADIK',
  'HGJCADEI',
  'CJEDAFLK',
  'CEIDAFLK',
  'CJEDAFLI',
  'CJEDAFIK',
  'HEFCADLK',
  'HJFCADLE',
  'HJECAFDK',
  'HEFCADLI',
  'HEFCADIK',
  'HJECAFDI',
  'CGEDAFLK',
  'CGJDAFLE',
  'CGJDAFEK',
  'CGEDAFLI',
  'CGEDAFIK',
  'CGJDAFEI',
  'HGFCADLE',
  'HGECAFDK',
  'HGJCAFDE',
  'HGECAFDI',
  'HJBAIGLK',
  'HJBAIFLK',
  'IJBFAGLK',
  'HJBFAGLK',
  'HGBAIFLK',
  'HJBFAGLI',
  'HJBFAGIK',
  'EJBAIHLK',
  'EJBAIGLK',
  'EJBAHGLK',
  'EGBAIHLK',
  'EJBAHGLI',
  'EJBAHGIK',
  'EJBAIFLK',
  'EJBFAHLK',
  'EIBFAHLK',
  'EJBFAHLI',
  'EJBFAHIK',
  'EJBFAGLK',
  'EGBAIFLK',
  'EJBFAGLI',
  'EJBFAGIK',
  'EGBFAHLK',
  'HJBFAGLE',
  'HJBFAGEK',
  'EGBFAHLI',
  'EGBFAHIK',
  'HJBFAGEI',
  'IJBDAHLK',
  'IJBDAGLK',
  'HJBDAGLK',
  'IGBDAHLK',
  'HJBDAGLI',
  'HJBDAGIK',
  'IJBDAFLK',
  'HJBDAFLK',
  'HIBDAFLK',
  'HJBDAFLI',
  'HJBDAFIK',
  'FJBDAGLK',
  'IGBDAFLK',
  'FJBDAGLI',
  'FJBDAGIK',
  'HGBDAFLK',
  'HGBDAFLJ',
  'HGBDAFJK',
  'HGBDAFLI',
  'HGBDAFIK',
  'HGBDAFIJ',
  'EJBAIDLK',
  'EJBDAHLK',
  'EIBDAHLK',
  'EJBDAHLI',
  'EJBDAHIK',
  'EJBDAGLK',
  'EGBAIDLK',
  'EJBDAGLI',
  'EJBDAGIK',
  'EGBDAHLK',
  'HJBDAGLE',
  'HJBDAGEK',
  'EGBDAHLI',
  'EGBDAHIK',
  'HJBDAGEI',
  'EJBDAFLK',
  'EIBDAFLK',
  'EJBDAFLI',
  'EJBDAFIK',
  'HEBDAFLK',
  'HJBDAFLE',
  'HJBDAFEK',
  'HEBDAFLI',
  'HEBDAFIK',
  'HJBDAFEI',
  'EGBDAFLK',
  'EGBDAFLJ',
  'EGBDAFJK',
  'EGBDAFLI',
  'EGBDAFIK',
  'EGBDAFIJ',
  'HGBDAFLE',
  'HGBDAFEK',
  'HGBDAFEJ',
  'HGBDAFEI',
  'IJBCAHLK',
  'IJBCAGLK',
  'HJBCAGLK',
  'IGBCAHLK',
  'HJBCAGLI',
  'HJBCAGIK',
  'IJBCAFLK',
  'HJBCAFLK',
  'HIBCAFLK',
  'HJBCAFLI',
  'HJBCAFIK',
  'CJBFAGLK',
  'IGBCAFLK',
  'CJBFAGLI',
  'CJBFAGIK',
  'HGBCAFLK',
  'HGBCAFLJ',
  'HGBCAFJK',
  'HGBCAFLI',
  'HGBCAFIK',
  'HGBCAFIJ',
  'EJBAICLK',
  'EJBCAHLK',
  'EIBCAHLK',
  'EJBCAHLI',
  'EJBCAHIK',
  'EJBCAGLK',
  'EGBAICLK',
  'EJBCAGLI',
  'EJBCAGIK',
  'EGBCAHLK',
  'HJBCAGLE',
  'HJBCAGEK',
  'EGBCAHLI',
  'EGBCAHIK',
  'HJBCAGEI',
  'EJBCAFLK',
  'EIBCAFLK',
  'EJBCAFLI',
  'EJBCAFIK',
  'HEBCAFLK',
  'HJBCAFLE',
  'HJBCAFEK',
  'HEBCAFLI',
  'HEBCAFIK',
  'HJBCAFEI',
  'EGBCAFLK',
  'EGBCAFLJ',
  'EGBCAFJK',
  'EGBCAFLI',
  'EGBCAFIK',
  'EGBCAFIJ',
  'HGBCAFLE',
  'HGBCAFEK',
  'HGBCAFEJ',
  'HGBCAFEI',
  'IJBCADLK',
  'HJBCADLK',
  'HIBCADLK',
  'HJBCADLI',
  'HJBCADIK',
  'CJBDAGLK',
  'IGBCADLK',
  'CJBDAGLI',
  'CJBDAGIK',
  'HGBCADLK',
  'HGBCADLJ',
  'HGBCADJK',
  'HGBCADLI',
  'HGBCADIK',
  'HGBCADIJ',
  'CJBDAFLK',
  'CIBDAFLK',
  'CJBDAFLI',
  'CJBDAFIK',
  'HFBCADLK',
  'CJBDAFLH',
  'HJBCAFDK',
  'HFBCADLI',
  'HFBCADIK',
  'HJBCAFDI',
  'CGBDAFLK',
  'CGBDAFLJ',
  'CGBDAFJK',
  'CGBDAFLI',
  'CGBDAFIK',
  'CGBDAFIJ',
  'CGBDAFLH',
  'HGBCAFDK',
  'HGBCAFDJ',
  'HGBCAFDI',
  'EJBCADLK',
  'EIBCADLK',
  'EJBCADLI',
  'EJBCADIK',
  'HEBCADLK',
  'HJBCADLE',
  'HJBCADEK',
  'HEBCADLI',
  'HEBCADIK',
  'HJBCADEI',
  'EGBCADLK',
  'EGBCADLJ',
  'EGBCADJK',
  'EGBCADLI',
  'EGBCADIK',
  'EGBCADIJ',
  'HGBCADLE',
  'HGBCADEK',
  'HGBCADEJ',
  'HGBCADEI',
  'CEBDAFLK',
  'CJBDAFLE',
  'CJBDAFEK',
  'CEBDAFLI',
  'CEBDAFIK',
  'CJBDAFEI',
  'HFBCADLE',
  'HEBCAFDK',
  'HJBCAFDE',
  'HEBCAFDI',
  'CGBDAFLE',
  'CGBDAFEK',
  'CGBDAFEJ',
  'CGBDAFEI',
  'HGBCAFDE',
];

const ANNEX_C_INDEX = new Map<string, number>(
  ANNEX_C_ROWS.map((row, index) => [
    row.split('').sort().join(''),
    index,
  ])
);

export function lookupAnnexCThirdGroup(
  qualifyingThirdGroups: string[],
  winnerGroup: string
): string | null {
  if (qualifyingThirdGroups.length !== 8) return null;
  const key = [...qualifyingThirdGroups].map((g) => g.toUpperCase()).sort().join('');
  const rowIndex = ANNEX_C_INDEX.get(key);
  if (rowIndex === undefined) return null;
  const colIndex = ANNEX_C_WINNERS.indexOf(winnerGroup.toUpperCase() as (typeof ANNEX_C_WINNERS)[number]);
  if (colIndex < 0) return null;
  return ANNEX_C_ROWS[rowIndex][colIndex] ?? null;
}
